<template>
  <div style="">
    <draggable v-model="imageList" class="primary-flex list-element">
      <div v-for="(item, index) in imageList" :key="index" style="margin-right: 10px;">
        <div class="upLoad-Image" v-if="item.url.length > 0">
          <el-image class="upLoad-Image" style="border: none;" :src="item.url"></el-image>
          <div class="close" style=" " @click="close(index)">╳</div>
        </div>
        <div v-else @click="chooseImage(index)" class="upLoad-Image">
          <i class="el-icon-picture-outline" style="font-size: 24px;"></i>
          <span>点击上传图片</span>
        </div>
      </div>
    </draggable>
    <!-- <el-button @click="consolea">输出 </el-button> -->
    <dyh-img-choose @imageChoose="imageChoose" :sougou="false" ref="dyhImgChooseRef"></dyh-img-choose>
  </div>

</template>
<script>
import draggable from 'vuedraggable';

import dyhImgChoose from '@/components/dyh-imgChoose.vue';

export default {
  name: 'dyhUpload',
  data() {
    return {
      imageList: []
      /* : {
        url: "",
        sort: "",
        alt: ""
      }, */

    };
  },
  props: {
    count: {
      type: Number,
      default: 1
    },
    startImageList: {
      type: Array
    },
    keys: {
      type: String,
      default: ''
    }
  },
  components: {
    dyhImgChoose, draggable
  },
  mounted() {
    for (let i = 0; i < this.count; i++) {
      this.imageList.push({
        url: "",
        sort: "",
        alt: "",
        media_no: ""
      });
    }
  },
  methods: {
    setBaseImage(image) {
      console.log("imageaaaaaaaaaaaaaaaaaaaaaaaaaaaa", image);
      if (image.length > 0) {
        for (let i = 0; i < image.length; i++) {
          this.$set(this.imageList, i, image[i]);
          /* this.imageList[i] = image[i]; */
        }
        console.log("this.imageList--setBaseImage", this.imageList);
      }
    },
    close(i) {
      this.imageList[i].url = "";
      this.$emit("dyhUploadReturn", { imageList: this.imageList });
    },
    /**
     * imageChoose组件返回
     * @param v
     */
    imageChoose(v) {
      console.log("vimageChoose", v);
      this.$nextTick(() => {
        const key = v.key;
        this.$set(this.imageList[key], "url", v.url);
        this.$set(this.imageList[key], "media_no", v.media_no);
        console.log("this.imageList", this.imageList);
        this.$emit("dyhUploadReturn", { imageList: this.imageList });
      })
    },
    /**
     * 打开图片选择组件
     * @param i
     */
    chooseImage(i) {
      this.$refs.dyhImgChooseRef.showDyhImageCooseDialog({ key: i });
    }
  }
};
</script>
<style lang="less" scoped>
.upLoad-Image {
  width: 120px;
  height: 120px;
  border: 1px dashed #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  border-radius: 5px;
  color: #333;
  position: relative;
  user-select: none;
}

.close {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  color: #fff;
  background-color: rgb(249, 96, 96);
  font-size: 16px;
  user-select: none;
}
</style>